import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/api';
import { SystemDropDownListI18nViewModel } from '../../common-api/common-api/model/systemDropDownListI18nViewModel';
import { isNullOrEmpty } from '../utils';

/**
 * 共用下拉選項
 *
 * @export
 * @class TranslatableDropdownOption
 * @implements {SelectItem}
 */
export class TranslatableDropdownOption implements SelectItem {
  dropdown: SystemDropDownListI18nViewModel;

  constructor(
    private translateService: TranslateService,
    private dropdownModel: SystemDropDownListI18nViewModel,
    private labelDisplayWithValue: boolean = false
  ) {
    this.dropdown = dropdownModel;
  }

  get label(): string | undefined {
    const currentLang = this.translateService.currentLang;
    const languageOther = this.dropdown.languageOther ?? [];
    let displaylabel =
      languageOther.find((x) => x.i18nCode === currentLang)?.i18nValue ??
      this.dropdown.languageEnglish;

    if (isNullOrEmpty(displaylabel)) {
      displaylabel =
        languageOther.find((x) => x.i18nCode === 'en-us')?.i18nValue ?? '';
    }

    if (this.labelDisplayWithValue) {
      return `${this.value} - ${displaylabel}`;
    }

    return displaylabel;
  }

  get value(): string | undefined {
    return this.dropdown.code;
  }

  get disabled(): boolean {
    return !this.dropdown.isEnable;
  }
}
